import { useQuery } from 'providers/tanstack-query/useQuery'
import { domainAmazonsFromDTO, DomainAmazonSliceDTO, GET_DOMAIN_AMAZONS } from './api'
import { Data } from './api/types'
import { DomainAmazonOption, UseGetDomainAmazons } from './types'

export const useGetDomainAmazons = (): UseGetDomainAmazons => {
  const { data } = useQuery<never, Data, DomainAmazonOption[]>({
    options: {
      select: ({ domainAmazons: { nodes } }: Data): DomainAmazonOption[] =>
        nodes?.map(
          (node: DomainAmazonSliceDTO): DomainAmazonOption => domainAmazonsFromDTO(node),
        ) ?? [],
    },
    query: GET_DOMAIN_AMAZONS,
  })

  return {
    options: data ?? [],
  }
}
